import { Pie} from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels';
export default {
    extends: Pie,
    props: {
        chartdata: {
            type: Object,
            default: null
        },
        options: {
            type: Object,
            default: null
        },
        activePie: {
            type: Number,
            default: null
        }
    },
    watch: {
        activePie: {
            immediate: true,
            handler(val,old) {

                if (val !== null ) {

                    const chart = this.$data._chart;
                    const data = chart.getDatasetMeta(0).data;
                    chart.update();

                    for (let i = 0, j = data.length; i < j; i++) {

                        if (i !== val) {
                            data[i]['_model'].outerRadius = this.radius - this.extramargin;
                            //chart.$datalabels['_labels'][val].$layout['_visible'] = false;
                        } else {

                        }
                    }

                }
            }
        }
    },
    data() {
        return {
            radius: 180,
            currentPie: null,
            extramargin: 10
        }
    },
    /**
     * Das Plugin wird benötigt zur Anzeige der Datenwerte. Über die Display Methode wird das gerade aktive Label gesteuert.
     */
    mounted () {
        const self = this;
        const options = Object.assign(this.options, {
            tooltips: false,

            onHover: (e, el) => {

                let elt = el[0];

                if (elt) {
                    let lbl = elt._model.label;
                    let elt_index = elt._chart.tooltip._data.labels.indexOf(lbl);
                    let val = elt._chart.tooltip._data.datasets[0].data[elt_index];

                    self.$emit('element-hovered', { idx:elt_index, label : lbl, value : val });
                }
            },

            plugins: {
                datalabels: {
                    formatter: function(value, context) {
                        return value + "%";
                    },
                    display: (context) => {
                        return context.dataIndex === this.activePie;
                    },
                    color: 'white',
                    labels: {
                        title: {
                            font: {
                                weight: 'bold',
                                size: '24',
                                color: 'white'
                            },

                        },
                    }
                }
            }
        })
        this.renderChart(this.chartdata,options);

        this.$data._chart.update();
    }
}
